export default "__VITE_PUBLIC_ASSET__faf05a8c__"